<template>
  <error-loading v-if="error" />
  <b-row v-else>
    <b-col cols="12" class="p-1">
      <newBasic
        :tiktokData="data.report.basic"
        :metrics="data.report.metrics"
        :features="data.report.features"
      ></newBasic>
      <mainCharts
        :tiktokData="data.report"
        :showEmbedTiktok="showEmbedTiktok"
      />
    </b-col>
    <b-col cols="12" class="p-1" v-if="data.report.features.blogger_views_likes_chart">
      <content-tiktok :media="mains" :graph="data.report.features.blogger_views_likes_chart.data" :username="data.report.basic.username" :showEmbedTiktok="showEmbedTiktok"/>
    </b-col>
    <b-col cols="12">
      <tiktok-media :contents="media" :media_ids="media_ids" v-if="media.length > 0 && !loading_cards"/>
      <div class="col-12 row m-0 p-0 justify-content-center" v-if="loading_cards">
        <b-col class="col-12 col-md-5 col-lg-3 mr-lg-2 ml-lg-2 p-lg-0" v-for="i in 6" :key="i">
          <b-card>
            <div class="d-flex align-items-center mb-1">
              <b-skeleton type="avatar" width="55px" height="55px" class="mr-2" />
              <div>
                <b-skeleton width="120px" />
                <b-skeleton width="80px"/>
              </div>
            </div>

            <b-skeleton type="image" width="100%" height="250px" class="mb-2" />

            <b-skeleton/>
            <b-skeleton/>
            <b-skeleton/>

          </b-card> 
        </b-col>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BSkeleton, BCard, } from 'bootstrap-vue'
import profile_services from '@/services/profile'
export default {
  components: {
    BRow,
    BCol,
    BSkeleton,
    BCard,
    newBasic: () => import('@/views/pages/profile/tiktok/newBasic.vue'),
    mainCharts: () => import('@/views/pages/profile/tiktok/charts/mainCharts.vue'),
    ContentTiktok: () => import('./ContentTiktok.vue'),
    ErrorLoading: () => import('../ErrorLoading.vue'),
    TiktokMedia: () => import('@/views/pages/profile/tiktok/TiktokMedia.vue')
  },
  props: {
    data: {
      Type: Object,
      required: false
    },
    error: {
      Type: Boolean,
      required: true
    },
    showEmbedTiktok: {
      Type: Boolean,
      required: true
    },
    headerData: {
      Type: Object,
      required: true
    },
  },
  data() {
    return {
      media: [],
      media_ids: {},
      loading_cards: false,
    }
  },
  computed: {
    mains() {
      return this.data.report.features.blogger_views_likes_chart.data.filter(item => item.is_recommended === true)
    }
  },
  created() {
    this.getMedia();
  },
  methods: {
    getMedia() {
      this.loading_cards = true;
      profile_services.getMedia(this.$route.params.alias ? this.$route.params.alias : this.$route.params.username, 'tiktok')
        .then(response => {
          const media_tiktok = response.media || {};
          const contents = Object.values(media_tiktok);

          const contents_format = contents.map(content => ({
            ...content,
            id: content.basic?.id,
            username: this.headerData.username,
            network: this.headerData.main.network,
            avatar: this.headerData.avatar ? this.headerData.avatar : this.data.report.basic.avatar_url,
            is_verified: this.headerData.is_verified
          }));

          this.media = contents_format;
          this.media_ids = response;
          this.loading_cards = false;
        });
    },
  }
}
</script>
